import Api from './api';

// Service pra consumir o historico enriquecido de execucoes de automacao (F3.1).
// Endpoints backend:
//   GET /automation/{id}/executions?page=&pageSize=&status=&from=&to=
//   GET /automation/executions/{batchId}/actions
//
// Sempre aplicar normalizeSummary/normalizeAction ao consumir — a API do 2DO
// serializa TUDO em lowercase sem separadores (ver rules/frontend-react.md).

export const getExecutionsByAutomation = (automationId, { page = 1, pageSize = 25, status = '', from = '', to = '' } = {}) => {
  const qs = new URLSearchParams();
  qs.append('page', page);
  qs.append('pageSize', pageSize);
  if (status) qs.append('status', status);
  if (from) qs.append('from', from);
  if (to) qs.append('to', to);
  return Api.get(`/automation/${automationId}/executions?${qs.toString()}`);
};

export const getActionsByBatch = (batchId) => Api.get(`/automation/executions/${batchId}/actions`);

// Normalizador do PAI — API responde tudo em lowercase concatenado.
// Regra: usar `??` (não `||`) pra preservar 0/false/''.
export const normalizeSummary = (raw) => ({
  ...raw,
  id: raw.id,
  automationId: raw.automationid ?? raw.automationId,
  automationGuid: raw.automationguid ?? raw.automationGuid,
  automationName: raw.automationname ?? raw.automationName,
  batchId: raw.batchid ?? raw.batchId,
  correlationId: raw.correlationid ?? raw.correlationId,
  causationId: raw.causationid ?? raw.causationId,
  eventGuid: raw.eventguid ?? raw.eventGuid,
  triggerType: raw.triggertype ?? raw.triggerType,
  actorId: raw.actorid ?? raw.actorId,
  retryCount: raw.retrycount ?? raw.retryCount ?? 0,
  createdAt: raw.createdat ?? raw.createdAt,
  executedAt: raw.executedat ?? raw.executedAt,
  durationMs: raw.durationms ?? raw.durationMs,
  status: raw.status,
  executionSuccess: raw.executionsuccess ?? raw.executionSuccess,
  errorCode: raw.errorcode ?? raw.errorCode,
  errorMessage: raw.errormessage ?? raw.errorMessage,
  totalActions: raw.totalactions ?? raw.totalActions ?? 0,
  successfulActions: raw.successfulactions ?? raw.successfulActions ?? 0,
  failedActions: raw.failedactions ?? raw.failedActions ?? 0,
  skippedActions: raw.skippedactions ?? raw.skippedActions ?? 0,
  ticketIds: raw.ticketids ?? raw.ticketIds ?? [],
  calledId: raw.calledid ?? raw.calledId,
  automationConfigHash: raw.automationconfighash ?? raw.automationConfigHash,
});

export const normalizeAction = (raw) => ({
  id: raw.id,
  hirerId: raw.hirerid ?? raw.hirerId,
  executionId: raw.executionid ?? raw.executionId,
  executionGuid: raw.executionguid ?? raw.executionGuid,
  calledId: raw.calledid ?? raw.calledId,
  automationId: raw.automationid ?? raw.automationId,
  actionId: raw.actionid ?? raw.actionId,
  actionTypeCode: raw.actiontypecode ?? raw.actionTypeCode ?? '',
  handlerName: raw.handlername ?? raw.handlerName,
  executionOrder: raw.executionorder ?? raw.executionOrder ?? 0,
  status: raw.status,
  startedAt: raw.startedat ?? raw.startedAt,
  durationMs: raw.durationms ?? raw.durationMs,
  errorCode: raw.errorcode ?? raw.errorCode,
  errorMessage: raw.errormessage ?? raw.errorMessage,
  outputMetadata: raw.outputmetadata ?? raw.outputMetadata,
});

export const normalizePagedResult = (raw) => ({
  page: raw.page ?? 1,
  pageSize: raw.pagesize ?? raw.pageSize ?? 25,
  totalCount: raw.totalcount ?? raw.totalCount ?? 0,
  totalPages: raw.totalpages ?? raw.totalPages ?? 0,
  items: Array.isArray(raw.items) ? raw.items.map(normalizeSummary) : [],
});
